module.exports = __webpack_public_path__ + "img/pencil-alt.63533c0e.svg";